import { Link } from "react-router";
import AvatarWithFallback from "~/molecules/AvatarWithFallback";
import MoreTooltip from "~/molecules/MoreTooltip";
import { TagsValue } from "~/molecules/Tags";
import { formatDate } from "~/helpers/date";
import { type AnchoringUser } from "~/api/v2/useAnchoringDocuments";
import { type QuizSummary } from "~/api/types";

export const UserCell = ({ user }: { user: AnchoringUser | null }) =>
  user ? (
    <AvatarWithFallback user={user} size="xs" withName showTooltip />
  ) : (
    <>-</>
  );

export const DateCell = ({ value }: { value: string | null }) => (
  <>{formatDate(value)}</>
);

export const TitleLinkCell = ({
  documentId,
  documentVersionId,
  title,
  tab,
}: {
  documentId: number;
  documentVersionId: number;
  title: string;
  tab?: string;
}) => {
  const tabParam = tab ? `&tab=${tab}` : "";
  return (
    <Link
      to={`/documents/${documentId}?versionId=${documentVersionId}${tabParam}`}
      className="text-primary hover:underline"
      onClick={(event) => event.stopPropagation()}
    >
      {title}
    </Link>
  );
};

export const TagsCell = ({ tags }: { tags: string[] }) => {
  if (tags.length === 0) return <>-</>;

  return (
    <div className="flex items-center gap-1">
      <TagsValue>{tags[0]}</TagsValue>
      <MoreTooltip data={tags} variant="tag" />
    </div>
  );
};

export const CountsCell = ({
  invitedCount,
  completedCount,
}: {
  invitedCount: number;
  completedCount: number;
}) => (
  <>
    {completedCount} / {invitedCount}
  </>
);

export const CreatedByCell = ({
  createdBy,
}: {
  createdBy: QuizSummary["createdBy"];
}) => {
  const name = [createdBy?.name, createdBy?.surname]
    .filter(Boolean)
    .join(" ")
    .trim();
  return <>{name || "-"}</>;
};
